import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';
import Lottie from 'react-lottie';

import {
  fetchPreviousOfflineConsultation,
  getAllRelatives,
  fetchConsultationBlocker,
  refundStatusOffline,
} from '../../services/consultation';
import { logEvent } from '../../utils/logEvent';
import Header from '../../components/common/Header';
import initializeFreshDesk from '../../utils/freshchat';
import {
  resetChat,
  setCurrentActiveTab,
  getPreBookedProcesses,
} from '../../actions';
import { PrimaryButton } from '../../components/common/Buttons';
import { FadeInTransition } from '../../components/transitions/transitions';
import ConsultationUser from '../../components/consultations/ConsultationUser';
import RefundStatusTele from '../../components/consultations/new-flow/RefundStatusTele';
import RelativeSelect from '../../components/consultations/RelativeSelect';
import LoadingSkeleton from '../../components/common/Skeleton/ConsultationStartPreview';
import AppointmentCard from '../../components/cards/AppointmentCard';

import noConsultationLottie from '../../lottie/no-consultations.json';
import OrImage from '../../images/pre-book/Or.svg';
import FooterButton from '../../components/common/FooterButton';
import PreBookInfoModal from '../../components/consultations/PreBookInfoModal';
import PatientModal from '../../components/common/PatientModal';
import { SERVICE_LINE_NAMES } from '../../config';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 100vh;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10rem;
  gap: 10px;
  height: 100vh;
`;
const PreBookDetails = styled.div`
  margin-top: -5px;
`;
const BodyInnerContainer = styled.div`
  // padding-left: 14px;
  // padding-right: 14px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

class ConsultationStartPreview extends Component {
  openSupport = () => {
    initializeFreshDesk(this.props.user);
  };

  constructor(props) {
    super(props);
    this.state = {
      verticals: [],
      showVerticalsLeftScroll: false,
      showVerticalsRightScroll: true,
      ongoingAppointment: [],
      completedAppointment: [],
      cards: [],
      relatives: [],
      selectedRelative: null,
      showRelativeModal: false,
      blockers: {},
      from: '',
      refundStatusModal: false,
      refundData: {},
      refundLoading: true,
      preBookCardDetails: [],
      offlineCardDetails: [],
      showPreBookInfoModal: false,
      selectedPreBookCard: null,
      preBookedData: null,
    };
    this.verticalScrollContainerRef = React.createRef();

    const { state } = this.props.location;
    if (state && state.openConsultId) {
      this.state.openConsultId = parseInt(state.openConsultId);
      this.openOrder(this.state.openConsultId);
    }
    if (state && state.from === 'home') {
      props.dispatch(setCurrentActiveTab('home'));
    } else {
      props.dispatch(setCurrentActiveTab('clinic-orders'));
    }
  }

  componentDidMount() {
    // GA tracking
    window.gtag('event', 'screen_view', {
      screen_name: 'Consult Screen',
    });
    this.props.dispatch(resetChat());
    this.getConsults('all');
    this.getAllRelatives();
    this.fetchConsultationBlocker();

    logEvent('Offline Appointments Home Screen');
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     prevProps.location.hash === '#profile' &&
  //     this.props.location.hash !== '#profile'
  //   ) {
  //     this.closeProfile();
  //     return;
  //   }

  //   if (
  //     prevState.selectedRelative &&
  //     this.state.selectedRelative !== prevState.selectedRelative
  //   ) {
  //     console.log(' this.state.selectedRelativ', this.state.selectedRelative);
  //     this.getConsults('all');
  //   }
  //   if (
  //     this.state.selectedRelative &&
  //     this.state.selectedRelative !== prevState.selectedRelative &&
  //     !this.state.loading
  //   ) {
  //     this.getConsults();
  //   }
  // }

  openOrder = (order) => {
    const { history } = this.props;
    if (order.type === 'reimbursement') {
      history.push('/consultation/reimbursement-details', {
        reimbursementId: order.reimbursementId,
        goBack: true,
      });
      return;
    }
    if (order.prebookStatus !== 'cl-generated' && order.prebookedAppointment) {
      logEvent('Self book Appointment created');
      this.props?.history?.push('/consultation/prebook-status', {
        requestId: order.requestId,
      });
      return;
    }
    history.push('/consultation/appointment/appointment-status', {
      requestId: order.requestId,
      blockers: this.state.blockers,
    });
  };

  onNext = () => {
    const { history } = this.props;
    const { selectedRelative, selectedIssues, selectedIssuesIndex } =
      this.state;
    if (this.searchType === 'treat') {
      history.push('/consultation/request-summary', {
        relative: selectedRelative,
        selectedIssues,
        selectedIssuesIndex,
      });
    } else {
      // Specialist search. Take directly to search screen
      history.push('/consultation/specialist-search', {
        issueIds: selectedIssuesIndex,
        onlineFilters: this.filters.ONLINE,
        offlineFilters: this.filters.OFFLINE,
        showOnlineAndOffline: true,
        consultRequestInfo: {
          selectedIssuesIndex,
          relative: selectedRelative,
        },
      });
    }
  };

  onVerticalListScrolled = (event) => {
    const { showVerticalsLeftScroll, showVerticalsRightScroll } = this.state;
    if (event.target.scrollLeft > 0) {
      !showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: true,
        });
    } else {
      showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: false,
        });
    }
    if (
      event.target.scrollLeft + event.target.clientWidth <
      event.target.scrollWidth
    ) {
      !showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: true });
    } else {
      showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: false });
    }
  };

  smoothScroll(ele, left, reverse) {
    const start = performance.now();
    const duration = 300;
    const startValue = ele.scrollLeft;
    const scrollPerTimestamp = Math.abs(left - startValue) / duration;
    const multiplier = reverse ? 1 : -1;
    const animate = (timestamp) => {
      const progress = timestamp - start;
      ele.scrollTo(startValue + multiplier * scrollPerTimestamp * progress, 0);
      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }

  scrollVerticalsLeft = () => {
    const { scrollLeft, clientWidth } = this.verticalScrollContainerRef.current;
    if (scrollLeft === 0) {
      return;
    }
    if (scrollLeft < clientWidth / 2) {
      this.smoothScroll(this.verticalScrollContainerRef.current, 0);
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft - clientWidth / 2
    );
  };

  scrollVerticalsRight = () => {
    const { scrollLeft, clientWidth, scrollWidth } =
      this.verticalScrollContainerRef.current;
    if (scrollLeft + clientWidth >= scrollWidth) {
      return;
    }
    if (scrollWidth - scrollLeft + clientWidth < clientWidth / 2) {
      this.smoothScroll(
        this.verticalScrollContainerRef.current,
        scrollWidth - clientWidth,
        true
      );
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft + clientWidth / 2,
      true
    );
  };

  getAllRelatives = () => {
    const { authToken, user } = this.props;
    getAllRelatives(authToken)
      .then((res) => {
        const self = {
          age: user.userAge,
          dob: user.dateOfBirth,
          gender: user.userGender,
          id: 'self',
          name: user.userName,
          phone: user.userPhone,
          relation: user.userType,
        };
        const relatives = [self, ...res.relatives];
        this.setState({
          relatives,
        });
      })
      .catch((err) => {
        console.error('Error in fetching relatives', err);
      });
  };

  getConsults(id = null) {
    const { authToken } = this.props;
    const { selectedRelative, openConsultId } = this.state;
    this.setState({
      loading: true,
    });
    if (!id) {
      id = this.state.selectedRelative?.id || 'all';
    }
    fetchPreviousOfflineConsultation(id, authToken)
      .then((res) => {
        const cards = res.cards;
        console.log('cards fetchPreviousOfflineConsultation', cards);

        const ongoingAppointment = res?.appointments?.filter((appointments) => {
          return appointments.status.ongoing === true;
        });
        const completedAppointment = res?.appointments?.filter(
          (appointments) => {
            return appointments.status.ongoing === false;
          }
        );

        if (openConsultId && res?.appointments?.length > 0) {
          const orderToOpen = res?.appointments?.filter((ele) => {
            return ele.consultationId === openConsultId;
          });
          if (orderToOpen.length === 1) {
            this.openOrder(orderToOpen[0]);
          }
        }
        if (res.appointments.length === 0 && selectedRelative) {
          // this.setState({ selectedRelative: null });
        }
        this.setState({
          completedAppointment,
          ongoingAppointment,
          preBookCardDetails: cards?.filter(
            (item) => item.label === 'You Book We Pay'
          ),
          offlineCardDetails: cards?.filter(
            (item) => item.label === 'Book Appointment Via Visit'
          ),
        });
      })
      .catch((err) => {
        console.error('Error in fetching consultation', err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  fetchConsultationBlocker = () => {
    fetchConsultationBlocker(this.props.authToken)
      .then((res) => {
        this.setState({
          blockers: res.blockers,
        });
      })
      .catch((err) => {
        console.error('Error in fetching consultation blocker', err);
      });
  };

  refundStatus = (requestId) => {
    this.setState({
      refundLoading: true,
    });
    refundStatusOffline(requestId, this.props.authToken)
      .then((res) => {
        this.setState({
          refundData: res?.refundDetails,
          refundLoading: false,
        });
      })
      .catch((err) => {
        console.error('Error in refundStatusOffline', err);
      });
  };

  hideModal = () => {
    this.setState({
      showRelativeModal: false,
    });
  };

  selectRelative = (ele) => {
    this.setState(
      {
        selectedRelative: ele,
      },
      () => {
        this.getConsults(ele?.id);
        this.hideModal();
      }
    );
  };

  closeRefundStatusModal = () => {
    this.setState({
      refundStatusModal: false,
    });
  };

  setRefundStatusModal = (status) => {
    this.setState({
      refundStatusModal: status,
    });
  };

  closeView = () => {
    if (this.props.magicBasedLogin) {
      if (typeof window.Android !== 'undefined') {
        window.Android.closeView();
        window.Android.closeView(true);
      } else if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
        window.webkit.messageHandlers.visitIosView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else {
        this.props.history.push('/home');
      }
    } else {
      this.props.history.push('/home');
    }
  };

  render() {
    const {
      selectedRelative,
      preBookCardDetails,
      offlineCardDetails,
      ongoingAppointment,
      completedAppointment,
      showRelativeModal,
      relatives,
      loading,
      blockers,
      showPreBookInfoModal,
      selectedPreBookCard,
    } = this.state;
    console.log('selectedRelative', selectedRelative);
    const { history } = this.props;
    const keyOption = {
      loop: true,
      autoplay: true,
      animationData: noConsultationLottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    // const ConsultationCard = (ele) => {
    //   if (ele.ongoing) {
    //     logEvent('Offline Consultation Ongoing Card', {
    //       screenName: 'Offline Home Screen',
    //       consultationId: ele.consultationId,
    //       requestId: ele.requestId,
    //     });
    //   }
    //   return (
    //     <ConsultationStatusCard
    //       key={ele.requestId}
    //       orderRequest={ele}
    //       onTap={() => this.openOrder(ele)}
    //     />
    //   );
    // };
    return (
      <FadeInTransition
        in={true}
        timeout={200}
        mountOnEnter
        unmountOnExit
        appear
      >
        <OuterContainer>
          <Header title={'Clinic Consultations'} onTap={this.closeView}>
            {relatives?.length > 1 && (
              <ConsultationUser
                text={selectedRelative ? selectedRelative.relation : 'All'}
                onTap={() => {
                  this.setState({
                    showRelativeModal: true,
                  });
                }}
              />
            )}
          </Header>
          <BodyContainer>
            <div>
              {offlineCardDetails &&
                offlineCardDetails.length > 0 &&
                offlineCardDetails?.map((card) => {
                  return (
                    <div
                      onClick={() => {
                        if (blockers.cancelledRequest > 0) {
                          history.push('/consultation/cancel-blocker', {
                            requestId: blockers.cancelledRequest,
                          });
                        } else if (blockers.pendingRequestId > 0) {
                          history.push(
                            '/consultation/appointment/appointment-status',
                            {
                              requestId: blockers.pendingRequestId,
                              goBack: true,
                              blockers: blockers,
                            }
                          );
                        } else {
                          logEvent('Book Appointment Via Visit clicked');
                          history.push('/consultation/start', {
                            showVertical: card.showVerticals,
                          });
                        }
                      }}
                    >
                      <img src={card.bannerImage} alt="Offline Card" />
                    </div>
                  );
                })}
            </div>

            {preBookCardDetails &&
              preBookCardDetails.length > 0 &&
              offlineCardDetails &&
              offlineCardDetails.length > 0 &&
              !loading && <img src={OrImage} alt="OrImage" />}
            <BodyInnerContainer>
              <PreBookDetails>
                {preBookCardDetails &&
                  preBookCardDetails.length > 0 &&
                  preBookCardDetails?.map((card) => {
                    return (
                      <div
                        onClick={() => {
                          logEvent(
                            'Funnel Offline Consultation Self Book Card Clicked'
                          );
                          this.props.dispatch(
                            getPreBookedProcesses((data) => {
                              this.setState({
                                showPreBookInfoModal: true,
                                selectedPreBookCard: card,
                                preBookedData: data,
                              });
                            })
                          );
                        }}
                      >
                        <img src={card.bannerImage} alt="Prebook Card" />
                      </div>
                    );
                  })}
              </PreBookDetails>
              {ongoingAppointment.length > 0 && (
                <div className="px-14px">
                  <div className="text-body-l font-semibold text-txtlight mb-20px ">
                    Ongoing
                  </div>
                  {ongoingAppointment.map((appt) => {
                    return (
                      <AppointmentCard
                        {...appt}
                        key={appt.requestId}
                        patientName={appt.patientName}
                        requestId={appt.requestId}
                        bookingDate={appt.bookedOn}
                        doctorName={appt.newDoctorName || appt.doctorName}
                        prevDoctorName={appt.previousDoctorName}
                        fees={appt.newFees || appt.doctorFees}
                        prevFees={appt.previousFees}
                        appointmentDate={appt.newDate || appt.appDate}
                        prevAppointmentDate={appt.previousDate}
                        slot={appt.newSlot || appt.timeSlot}
                        prevSlot={appt.previousSlot}
                        pendingCopay={Number(appt.coPay || 0)}
                        status={appt.status}
                        onTap={() => this.openOrder(appt)}
                        cancelCharge={appt.cancelAppointmentCharge}
                        modalText={appt.noShowText}
                        onReload={(id) => this.getConsults(id)}
                        letter={appt.cashlessLetterLink}
                        tooltipText={appt.status.toolTip}
                      />
                    );

                    // return ConsultationCard(appt)
                  })}
                </div>
              )}
              {completedAppointment.length > 0 && !loading && (
                <div className="px-14px">
                  <div className="text-body-l font-semibold text-txtlight mb-8 mt-8">
                    Completed
                  </div>
                  {completedAppointment.map((appt) => {
                    return (
                      <AppointmentCard
                        {...appt}
                        key={appt.requestId}
                        patientName={appt.patientName}
                        requestId={appt.requestId}
                        bookingDate={appt.bookedOn}
                        doctorName={appt.newDoctorName || appt.doctorName}
                        prevDoctorName={appt.previousDoctorName}
                        fees={appt.newFees || appt.doctorFees}
                        prevFees={appt.previousFees}
                        appointmentDate={appt.newDate || appt.appDate}
                        prevAppointmentDate={appt.previousDate}
                        slot={appt.newSlot || appt.timeSlot}
                        prevSlot={appt.previousSlot}
                        pendingCopay={Number(appt.coPay || 0)}
                        status={appt.status}
                        onTap={() => this.openOrder(appt)}
                        letter={appt.cashlessLetterLink}
                        cancelCharge={appt.cancelAppointmentCharge}
                        modalText={appt.noShowText}
                        onReload={(id) => this.getConsults(id)}
                        tooltipText={appt.status.toolTip}
                        setRefundStatusModal={this.setRefundStatusModal}
                        refundStatus={this.refundStatus}
                      />
                    );
                  })}

                  {/* {completedAppointment.map(ConsultationCard)} */}
                </div>
              )}
              <div className="px-14px h-full">
                {loading ? (
                  <div style={{ height: '100svh', background: '#ffffff' }}>
                    <LoadingSkeleton />
                  </div>
                ) : (
                  ongoingAppointment?.length === 0 &&
                  completedAppointment?.length === 0 && (
                    <div className="flex flex-col justify-center items-center w-full h-full pb-20px">
                      <Lottie options={keyOption} width={'60%'} />
                      <p className="text-title-l text-primary-button font-bold text-center">
                        Nothing to see here!
                      </p>
                      {/* <PrimaryButton
                        className="w-full"
                        onTap={() => history.push('/consultation/start')}
                      >
                        <div className="text-body-l font-bold text-center py-4px">
                          Book Appointment
                        </div>
                      </PrimaryButton> */}
                      <FooterButton
                        onClick={() => history.push('/consultation/start')}
                        buttonText={'Book Appointment'}
                      />
                    </div>
                  )
                )}
              </div>
            </BodyInnerContainer>
            {showRelativeModal && (
              <PatientModal
                serviceLine={SERVICE_LINE_NAMES.OFFLINE}
                hideModal={this.hideModal}
                selectedPatient={selectedRelative}
                selectPatient={this.selectRelative}
              />
            )}
          </BodyContainer>
          {this.state.refundStatusModal && (
            <RefundStatusTele
              closeModal={this.closeRefundStatusModal}
              refundData={{ ...this.state.refundData, type: 'offline' }}
              refundLoading={this.state.refundLoading}
            />
          )}

          {showPreBookInfoModal && (
            <PreBookInfoModal
              data={this.state.preBookedData}
              onClose={() => this.setState({ showPreBookInfoModal: false })}
              onComplete={() => {
                this.setState({ showPreBookInfoModal: false });
                history.push('/consultation/start', {
                  showVertical: selectedPreBookCard?.showVerticals,
                  card: 'pre-book-appointment',
                });
              }}
            />
          )}
        </OuterContainer>
      </FadeInTransition>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  user: state.user,
  magicBasedLogin: state.app.magicBasedLogin,
  preBookedProcesses: state.app.preBookedProcesses,
});

export default connect(mapStateToProps)(ConsultationStartPreview);
